import { Box } from '@mui/material';
import logo from '../assets/Linkway/LinkwayLogoText2.png';
import logoIcon from '../assets/Linkway/LinkwayLogo.png';
const Logo = ({ icon = false, width = '50%', centre = false }) => {
  return (
    <Box sx={{ display: 'grid', placeItems: centre ? 'center' : 'flex-start', p: 1 }}>
      <img src={icon ? logoIcon : logo} alt='logo' width={width} style={{ objectFit: 'contain' }} />
    </Box>
  );
};

export default Logo;
